import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Folder, ClipboardList, Users } from 'lucide-react';

export const reportingManagerNav = (isHovered, styles) => {
     const is_radiology_doctor = (sessionStorage.getItem('is_radiology_doctor') || 'N').toUpperCase();

     return (
          <>
               <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Home size={20} style={{ marginRight: "8px" }} />
                    {isHovered && <span>Dashboard</span>}
               </NavLink>

               {is_radiology_doctor === "Y" && (
                    <NavLink
                         to="/manager-radiology-assessment"
                         style={({ isActive }) => ({
                              ...styles.navItem,
                              ...(isActive ? styles.navItemActive : {})
                         })}
                    >
                         <ClipboardList size={20} style={{ marginRight: "8px" }} />
                         {isHovered && <span>Manager Radiology Assessment</span>}
                    </NavLink>
               )}

               <NavLink
                    to="/dutyroster"
                    style={({ isActive }) => ({
                         ...styles.navItem,
                         ...(isActive ? styles.navItemActive : {}),
                    })}
               >
                    <Folder size={20} style={{ marginRight: "8px" }} />
                    {isHovered && <span>Duty Roster</span>}
               </NavLink>

               <NavLink
                    to="/split-duty-roster"
                    style={({ isActive }) => ({
                         ...styles.navItem,
                         ...(isActive ? styles.navItemActive : {}),
                         fontSize: '14px',
                         padding: '6px 12px',
                    })}
               >
                    <ClipboardList size={20} style={{ marginRight: '8px' }} />
                    {isHovered && <span>Split Duty Roster</span>}
               </NavLink>

               <NavLink
                    to="/employee-attendance"
                    style={({ isActive }) => ({
                         ...styles.navItem,
                         ...(isActive ? styles.navItemActive : {}),
                    })}
               >
                    <ClipboardList size={20} style={{ marginRight: "8px" }} />
                    {isHovered && <span>Employee Attendance</span>}
               </NavLink>
               <NavLink
                    to="/dutyrosterbulk"
                    style={({ isActive }) => ({
                         ...styles.navItem,
                         ...(isActive ? styles.navItemActive : {}),
                    })}
               >
                    <Folder size={20} style={{ marginRight: "8px" }} />
                    {isHovered && <span>Duty Roster Bulk</span>}
               </NavLink>
               {/* regularize */}
               {/* <NavLink to="/regularize" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <ClipboardList size={20} />
                    {isHovered && <span>Regularize Requests</span>}
               </NavLink> */}
               {/* on duty doctors */}
               <NavLink to="/citywise-on-duty-doctors" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Users size={20} />
                    {isHovered && <span>Doctors On Duty</span>}
               </NavLink>
          </>
     );
};